module.exports = __webpack_public_path__ + "img/attention-fill.811dc296.svg";